import app from 'app';
import gettyFilters from './creativeFilters.json';

export default {
  state() {
    const allowedProviders = function (isCreative) {
      const org = tk.context.organization;
      const key = isCreative ? 'providerDynamicMetadatas' : 'providerMetadatas';
      const providers = org[key] || [];

      providers.sort(function ascending(a, b) {
        const nameA = a.displayText.toLowerCase();
        const nameB = b.displayText.toLowerCase();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });

      return _.map(providers, (p) =>
        Object.assign({}, p, { selected: p.selectedByDefault })
      );
    };

    const providers = allowedProviders();
    const creativeProviders = allowedProviders(true);
    const videoProvider = creativeProviders.find((p) => p.id.includes('video'));
    const imageProvider = creativeProviders.find((p) => p.id.includes('image'));
    const creativeProviderIds = {
      video: videoProvider?.id,
      image: imageProvider?.id,
    };

    const ignoreCreativeFilterProviders = [
      'ClipStock_videos_dynamic',
      'Shutterstock_images_dynamic',
      'Shutterstock_videos_dynamic',
    ];
    const creativeFilters =
      ignoreCreativeFilterProviders.includes(creativeProviderIds.image) ||
      ignoreCreativeFilterProviders.includes(creativeProviderIds.video)
        ? null
        : gettyFilters;

    const defaultFilters = {
      WOCHIT: {
        providers,
        orientation: [],
        dateRange: {
          dateSearch: null,
          customDates: null,
        },
        videoQuality: null,
      },
      WOCHIT_CREATIVE: creativeFilters,
      MY_GALLERY: {
        format: null,
        dateRange: {
          dateSearch: null,
          customDates: null,
        },
        videoQuality: null,
      },
      [app.PROVIDERS.FAVORITES.id]: {
        format: null,
        orientations: [],
        dateRange: {
          dateSearch: null,
          customDates: null,
        },
        videoQuality: null,
      },
    };

    const state = {
      moduleAttached: true,
      defaultFilters,
      searchInProgress: false,
      searchFailedError: null,
      searchContextId: null,
      galleryUploadingAssets: app.UploadQueue.getVisualQue().map(
        (m) => m.attributes
      ),
      creativeProviders: creativeProviderIds,
      assetSearchResults: [],
      noMoreAssets: false,
      assetBuffer: [],
      assetWidth: 0,
      assetHeight: 0,
      searchTags: [],
      sidebarState: null, // null / 'filter' / 'story'
      searchPattern: '',
      myUploadsOnly: false,
      myFavoritesOnly: false,
      searchContexts: {
        WOCHIT: {
          queryProp: 'q',
          countProp: 'numberOfItems',
          nextItemProp: 'startItem',
          queryRequired: false,
          showFormatSelector: true,
          placeholder: 'Search media',
          query: {
            text: '',
            value: '',
          },
          selectedTags: [],
          nextItem: 0,
          openFilterTabs: [],
          filters: _.cloneDeep(defaultFilters.WOCHIT),
          sortBy: 'date',
          props: {
            tags: null,
            user: '',
            searchPrivateAssets: false,
            format: null,
          },
        },
        WOCHIT_CREATIVE: {
          queryProp: 'phrase',
          countProp: 'pageSize',
          nextItemProp: 'page',
          queryRequired: false,
          showFormatSelector: true,
          placeholder: 'Search media',
          query: {
            text: '',
            value: '',
          },
          providers: creativeProviders,
          selectedTags: [],
          nextItem: 1,
          openFilterTabs: [],
          filters: _.cloneDeep(defaultFilters.WOCHIT_CREATIVE),
          sortBy: 'RELEVANCE',
          props: {
            format: null,
          },
        },
        GIF: {
          query: {
            text: '',
            value: '',
          },
          props: {},
          placeholder: 'Search KLIPY',
          queryProp: 'q',
          countProp: 'count',
          nextItem: null,
          nextItemProp: { request: 'pos', response: 'next' },
          queryRequired: false,
        },
        TWITTER: {
          query: {
            text: '',
            value: '',
          },
          props: {},
          placeholder: 'Search on Twitter',
          queryProp: 'q',
          countProp: 'count',
          nextItemProp: 'maxId',
          queryRequired: true,
          nextItem: null,
        },
        INSTAGRAM: {
          query: {
            text: '',
            value: '',
          },
          placeholder: 'Enter a full Instagram handle (@username)',
          queryProp: 'id',
          countProp: 'count',
          nextItemProp: {
            request: 'instagramNextAssetId',
            response: 'nextAssetId',
          },
          nextItem: null,
          queryRequired: true,
          entity: null,
          props: {
            type: 'USERNAME',
            id: '',
            count: 60,
          },
        },
        MY_GALLERY: {
          queryProp: 'q',
          countProp: 'numberOfItems',
          nextItemProp: 'startItem',
          nextItem: 0,
          queryRequired: false,
          query: {
            text: '',
            value: '',
          },
          openFilterTabs: [],
          filters: _.cloneDeep(defaultFilters.MY_GALLERY),
          placeholder: 'Search My Team’s Uploads',
          props: {
            queryTags: false,
            tags: null,
            searchPrivateAssets: true,
            format: '',
          },
        },
        KALTURA: {
          query: {
            text: '',
            value: '',
          },
          props: {},
          placeholder: 'Search in My Library',
          queryProp: 'q',
          countProp: 'count',
          nextItem: null,
          nextItemProp: 'nextPage',
          queryRequired: false,
        },
        WOCHIT_OWNED_ASSETS: {
          queryProp: 'q',
          nextItem: 0,
          countProp: 'numberOfItems',
          nextItemProp: 'startItem',
          query: {
            text: '',
            value: '',
          },
          props: {},
          placeholder: 'Search in Wochit Owned Assets',
          queryRequired: false,
        },
        [app.PROVIDERS.FAVORITES.id]: {
          queryProp: 'q',
          countProp: 'numberOfItems',
          nextItemProp: 'startItem',
          nextItem: 0,
          queryRequired: false,
          query: {
            text: '',
            value: '',
          },
          selectedTags: [],
          openFilterTabs: [],
          filters: _.cloneDeep(defaultFilters[app.PROVIDERS.FAVORITES.id]),
          customFiltersOptions: {
            format: {
              INSTAGRAM: true,
              TWITTER: true,
            },
          },
          placeholder: 'Search Favorites',
          sortBy: 'FAVORITE_CREATION',
          props: {
            queryTags: false,
            tags: null,
            searchPrivateAssets: true,
            format: '',
          },
        },
      },
      sortContext: {
        [app.PROVIDERS.WOCHIT.id]: {
          onlyOnSearch: true,
          options: [
            {
              id: 'date',
              label: app.culture.get('sort.newest'),
              sortBy: 'date',
              asc: false,
            },
            {
              id: 'date_asc',
              label: app.culture.get('sort.oldest'),
              sortBy: 'date',
              asc: true,
            },
            { id: 'title', label: app.culture.get('sort.bestMatch') },
          ],
        },
        [app.PROVIDERS.WOCHIT_CREATIVE.id]: {
          onlyOnSearch: true,
          options: [
            { id: 'RELEVANCE', label: app.culture.get('sort.bestMatch') },
            { id: 'DATE', label: app.culture.get('sort.popular') },
          ],
        },
        [app.PROVIDERS.GIF.id]: void 0,
        [app.PROVIDERS.TWITTER.id]: void 0,
        [app.PROVIDERS.MY_GALLERY.id]: void 0,
        [app.PROVIDERS.FAVORITES.id]: {
          options: [
            {
              id: 'FAVORITE_CREATION',
              label: app.culture.get('sort.favoriteAdded'),
              sortBy: 'FAVORITE_CREATION',
              asc: false,
            },
            {
              id: 'FAVORITE_CREATION_asc',
              label: app.culture.get('sort.earliestAdded'),
              sortBy: 'FAVORITE_CREATION',
              asc: true,
            },
            {
              id: 'date',
              label: app.culture.get('sort.newest'),
              sortBy: 'date',
              asc: false,
            },
            {
              id: 'date_asc',
              label: app.culture.get('sort.oldest'),
              sortBy: 'date',
              asc: true,
            },
            { id: null, label: app.culture.get('sort.bestMatch') },
          ],
        },
      },
      favoriteInProcess: {},
      defaultAssetGalleryTabs: [
        {
          id: app.PROVIDERS.WOCHIT.id,
          label: 'Editorial',
          classes: { backgroundColor: 'wt2-bgcolor-primary' },
        },
        {
          id: app.PROVIDERS.WOCHIT_CREATIVE.id,
          label: 'Creative',
          classes: { backgroundColor: 'wt2-bgcolor-primary' },
        },
        // {
        //   id: app.PROVIDERS.INSTAGRAM.id,
        //   label: 'Instagram',
        //   classes: { backgroundColor: 'wt2-bgcolor-primary' },
        //   hideFromImpededTempletiser: true,
        // },
        // {
        //   id: app.PROVIDERS.TWITTER.id,
        //   label: 'Twitter',
        //   classes: { backgroundColor: 'wt2-bgcolor-primary' },
        //   hideFromImpededTempletiser: true,
        // },
        {
          id: app.PROVIDERS.GIF.id,
          label: 'GIFs',
          classes: { backgroundColor: 'wt2-bgcolor-primary' },
          hideFromImpededTempletiser: true,
        },
        {
          id: app.PROVIDERS.MY_GALLERY.id,
          label: app.culture.get('userUploads.regularTitle'),
          classes: { backgroundColor: 'wt2-bgcolor-primary' },
          icon: 'wticon-folder',
        },
        {
          id: app.PROVIDERS.KALTURA.id,
          label: 'My Library',
          classes: { backgroundColor: 'wt2-bgcolor-primary' },
          icon: 'wticon-folder kaltura-icon',
        },
        {
          id: app.PROVIDERS.FAVORITES.id,
          label: 'Favorites',
          classes: { backgroundColor: 'wt2-bgcolor-primary' },
          icon: 'wticon-star favorite-tab-icon',
        },
        {
          id: app.PROVIDERS.WOCHIT_OWNED_ASSETS.id,
          label: 'Wochit Owned Assets',
          classes: { backgroundColor: 'wt2-bgcolor-primary' },
        },
      ],
    };

    return state;
  },

  // @param [state, getters, rootState, rootGetters]
  getters: {
    searchContextId(state) {
      return state.searchContextId;
    },

    contextObject(state) {
      return state.searchContexts[state.searchContextId];
    },

    contextFilters(state, getters) {
      return getters.contextObject.filters;
    },

    assetSearchResults(state) {
      return state.assetSearchResults;
    },

    contextFiltersParamsCreative(state) {
      const searchContext =
        state.searchContexts[app.PROVIDERS.WOCHIT_CREATIVE.id];
      const provider = app.PROVIDERS[app.PROVIDERS.WOCHIT_CREATIVE.id];
      const url = app.PROVIDERS[app.PROVIDERS.WOCHIT_CREATIVE.id].url();
      const query = searchContext.query.value;
      const { filters, nextItem, countProp } = searchContext;

      let nextItemProp = searchContext.nextItemProp;
      if (_.isString(nextItemProp)) {
        nextItemProp = { request: nextItemProp, response: nextItemProp };
      }

      const queryObj = _.isEmpty(query)
        ? {}
        : {
            [searchContext.queryProp]: query,
          };

      const refillCount = searchContext.format
        ? provider.REFILL_COUNT
        : provider.REFILL_COUNT / 2;
      const props = Object.assign({}, searchContext.props, queryObj, {
        [countProp]: refillCount,
      });

      props.sortBy = searchContext.sortBy;

      if (!!nextItem || nextItem === 0) {
        props[nextItemProp.request] = nextItem;
      }

      const getFilter = (format) => {
        const res = {};
        for (const [, filter] of Object.entries(filters)) {
          if (filter.format === format || !filter.format) {
            const selectedOptions = filter.options
              .filter((o) => o.selected)
              .map((o) => o.value);
            if (selectedOptions.length) {
              res[filter.prop] = (res[filter.prop] || []).concat(
                ...selectedOptions
              );
            }
          }
        }
        if (!_.isEmpty(res)) {
          return res;
        }
      };

      const isImages = !props.format || props.format === 'IMAGE';
      const isVideos = !props.format || props.format === 'VIDEO';

      let imageProps;
      let videoProps;

      if (filters) {
        if (isImages) {
          imageProps = getFilter('IMAGE');
        }
        if (isVideos) {
          videoProps = getFilter('VIDEO');
        }
      }

      return { url, props, imageProps, videoProps, countProp, nextItemProp };
    },

    contextFiltersParams(state, getters) {
      const contextId = state.searchContextId;
      const isInstagram = contextId === 'INSTAGRAM';
      const searchContext = state.searchContexts[contextId];
      const provider = app.PROVIDERS[contextId];
      let url = provider.url(
        isInstagram ? searchContext.props.type : searchContext.props.format
      ); // format is relevant to MY_GALLERY, to tell between Infographics and the rest.
      // When not in MY_GALLERY, url() will be called with undefined.
      const query = searchContext.query.value;
      let { nextItem, nextItemProp, countProp } = searchContext;
      if (_.isString(nextItemProp)) {
        nextItemProp = { request: nextItemProp, response: nextItemProp };
      }

      const orgIdLS = localStorage.getItem('selectedOrganizationId');
      let orgId = null;
      let progId = null;

      if (
        (contextId === app.PROVIDERS.MY_GALLERY.id && !state.myUploadsOnly) ||
        (contextId === app.PROVIDERS.FAVORITES.id && !state.myFavoritesOnly)
      ) {
        orgId = orgIdLS;
      }

      if (contextId === app.PROVIDERS.WOCHIT.id) {
        progId = getters.storyProgrammer.id;
      }

      const props = Object.assign({}, searchContext.props, {
        user: app.rootStore.getters['user/id'],
        orgId,
        prog: progId,
        [searchContext.queryProp]: query,
        [countProp]: provider.RESULTS_PER_PAGE,
      });
      if (contextId === app.PROVIDERS.WOCHIT.id) {
        props.contentFamily = 'Editorial';
      }

      if (!!nextItem || nextItem === 0) {
        props[nextItemProp.request] = nextItem;
      }

      if (searchContext.sortBy) {
        // A sort option's `id` is just a UI key. The backend sort field lives
        // in the option's `sortBy` (falling back to the id), and direction in
        // the `asc` boolean — asc=true → ascending, omitted → descending.
        const sortMeta = state.sortContext[contextId];
        const activeSortOption =
          sortMeta &&
          sortMeta.options.find((option) => option.id === searchContext.sortBy);
        props.sortBy =
          activeSortOption && activeSortOption.sortBy !== undefined
            ? activeSortOption.sortBy
            : searchContext.sortBy;
        if (activeSortOption && activeSortOption.asc !== undefined) {
          props.asc = activeSortOption.asc;
        }
      }

      if (searchContext.selectedTags && searchContext.selectedTags.length) {
        props.tags = searchContext.selectedTags.join(',');
      }

      const filters = getters.contextFilters;

      if (filters) {
        const contextId = state.searchContextId;

        if (_.isDefined(filters.restrictions)) {
          props.restrictions = filters.restrictions;
        }

        if (_.isDefined(filters.format)) {
          props.format = filters.format;
          url = app.PROVIDERS[contextId].url(props.format);
        }

        if (filters.orientation && filters.orientation.length) {
          props.orientation = filters.orientation
            .join('|')
            .replace('SQUARE', 'UNKNOWN');
        }

        if (filters.videoQuality && filters.videoQuality.length) {
          props.videoQuality = filters.videoQuality;
        }

        if (filters.providers) {
          const providers = filters.providers;
          let providerIds;
          if (_.some(providers, (p) => p.selected)) {
            providerIds = _.chain(providers)
              .filter({ selected: true })
              .map((p) => p.id)
              .value();
          } else {
            // ux thing. chosen none = selected all. https://youtu.be/aqAUmgE3WyM
            providerIds = _.chain(providers)
              .map((p) => p.id)
              .value();
          }

          props.providerId = providerIds.join('|');
        }

        if (filters.dateRange) {
          const dateSearch = filters.dateRange.dateSearch;

          if (_.isNumber(dateSearch)) {
            if (dateSearch === -1) {
              props.fromDate = -2208997240; // 1900's, weird scenario I know.
            } else {
              // props.fromDate = Date.now() - dateSearch *
              //     24 * 3600 * 1000; // date X days ago in milliseconds;
              props.fromDate =
                app
                  .moment()
                  .subtract(dateSearch + 1, 'day')
                  .valueOf() - 1;
            }
          } else if (_.isArray(dateSearch)) {
            props.fromDate = dateSearch[0] || null;
            props.toDate =
              (dateSearch[1] &&
                app.moment(dateSearch[1]).endOf('day').valueOf()) ||
              null;
          }
        }
      }

      return { url, props, nextItemProp };
    },

    hasDefaultContextFilters(state, getters) {
      if (getters.contextFilters) {
        return _.isEqual(
          getters.contextFilters,
          state.defaultFilters[state.searchContextId]
        );
      }
      return true;
    },

    afterSearchProcessResult: (state, getters) => (assets) => {
      // merged assets with entity results
      if (
        getters.contextObject.entity &&
        getters.contextObject.entity.type === 'USERNAME'
      ) {
        _.forEach(assets, (metaAsset) => {
          metaAsset._instagramProfileFetched = true;
          Object.assign(metaAsset.metadata, {
            socialUserScreenName:
              metaAsset.instagramAssetMetadata.socialUserScreenName,
            socialUserName: metaAsset.instagramAssetMetadata.socialUserName,
            socialUserProfileImageUrl:
              metaAsset.instagramAssetMetadata.socialUserProfileImageUrl,
          });
        });
      }

      // filter-out uploading from regular results
      assets = _.filter(assets, (asset) => !getters.isGalleryUploading(asset));

      return assets;
    },

    isGalleryUploading(state) {
      return function (asset) {
        return _.find(state.galleryUploadingAssets, (uploadingAsset) => {
          return uploadingAsset.metadata.assetUUID === asset.metadata.assetUUID;
        });
      };
    },

    isAssetProcessingFavorite: (state) => (asset) => {
      const identifier = app.assetUniqueIdentifier(asset);
      return Object.getOwnPropertyDescriptor(
        state.favoriteInProcess,
        identifier
      );
    },

    displayedAssetGalleryTabs(state, getters, rootState, rootGetters) {
      const wochitProviders =
        state.searchContexts[app.PROVIDERS.WOCHIT.id].filters.providers;

      const wochitCreativeProviders = (
        state.searchContexts[app.PROVIDERS.WOCHIT_CREATIVE.id].providers || []
      ).filter((p) => p.id != 'kaltura');

      return state.defaultAssetGalleryTabs.filter((tab) => {
        if (
          app.PROVIDERS.WOCHIT.id === tab.id &&
          (_.isEmpty(wochitProviders) ||
            !tk.context.organization.enableEditorialMediaInStudio)
        ) {
          return false;
        }

        if (
          app.PROVIDERS.WOCHIT_CREATIVE.id === tab.id &&
          _.isEmpty(wochitCreativeProviders)
        ) {
          return false;
        }

        if (
          tab.hideFromImpededTempletiser &&
          rootGetters['user/isImpededTemplatizer']
        ) {
          return false;
        }

        if (app.isEmbedded) {
          if (app.PROVIDERS.MY_GALLERY.id === tab.id) {
            return false;
          }
          if (
            app.PROVIDERS.KALTURA.id === tab.id &&
            !app.api.assetGallery.kalturaProperties
          ) {
            return false;
          }
        } else {
          if (app.PROVIDERS.KALTURA.id === tab.id) {
            return false;
          }
        }

        const isShutterStockInDynamicProviders =
          !!tk.context.organization.providerDynamicMetadatas?.find(
            (providerDynamicMetadata) =>
              providerDynamicMetadata.id.startsWith('Shutterstock')
          );
        if (
          app.PROVIDERS.WOCHIT_OWNED_ASSETS.id === tab.id &&
          (!rootGetters['user/isTemplateSpecialist'] ||
            !isShutterStockInDynamicProviders)
        ) {
          return false;
        }
        return true;
      });
    },
  },

  // @param [state]
  // @param [payload]
  mutations: {
    addGalleryUploadingAsset(state, payload) {
      state.galleryUploadingAssets.unshift(payload.asset);
    },

    removeGalleryUploadingAsset(state, asset) {
      const assetIndex = state.galleryUploadingAssets.findIndex(
        ({ metadata: { assetUUID } }) => assetUUID === asset.metadata.assetUUID
      );

      // first - try to find by instance
      if (assetIndex >= 0) {
        delete asset._uploading;
        state.galleryUploadingAssets.splice(assetIndex, 1);
      }
    },

    resetContextFilters(state, contextId) {
      const currentContext = state.searchContexts[contextId];
      const filtersProp = 'filters';
      app.Vue.set(
        currentContext,
        filtersProp,
        _.cloneDeep(state.defaultFilters[contextId])
      );
    },

    changeSearchContext(state, { id: newContextId, initialValue }) {
      const currentContext = this.getters.contextObject;
      const currentQuery = currentContext.query;
      const newContext = state.searchContexts[newContextId];
      if (newContextId === 'MY_GALLERY' || newContextId === 'FAVORITES') {
        if (currentQuery.text !== newContext.query.text) {
          currentQuery.text = '';
          currentQuery.value = '';
          newContext.query.text = '';
          newContext.query.value = '';
          state.searchPattern = '';
          state.searchContexts.INSTAGRAM.entity = null;
          state.searchContexts.WOCHIT.selectedTags = [];
        }
      } else if (newContextId === 'INSTAGRAM') {
        if (newContext.query.text !== currentQuery.text) {
          state.searchPattern = newContext.query.text = initialValue;
          newContext.query.value = null;
        }
      } else {
        state.searchPattern =
          newContext.query.text =
          newContext.query.value =
            initialValue;
      }
      state.searchContextId = newContextId;
    },

    setAssetBuffer(state, assets) {
      state.assetBuffer = assets;
    },

    assetMetadataEdited(/* state*/) {},

    resetSelectedTags(state) {
      state.searchContexts.WOCHIT.selectedTags = [];
    },

    resetSearchResults(state, options) {
      options = Object.assign(
        {
          resetSelectedTags: false,
        },
        options
      );
      state.assetSearchResults = [];
      state.assetBuffer = [];
      state.nextStartItem = null;
      state.noMoreAssets = false;
      this.getters.contextObject.nextItem = null;
      state.searchTags = [];
      if (options.resetSelectedTags) {
        state.searchContexts.WOCHIT.selectedTags = [];
      }
    },

    setSearchTags(state, assets) {
      state.searchTags = assets;
    },

    setProviderSelection(state, { id, selected }) {
      const provider = _.find(this.getters.contextFilters.providers, { id });
      provider.selected = selected;
    },

    setQuery(state, query) {
      const currentContext = this.getters.contextObject;
      currentContext.query.text = query.text;
      currentContext.query.value = query.value;
      state.searchPattern = query.text;
    },

    setCurrentSearchContextProps(state, props) {
      const currentContext = this.getters.contextObject;
      for (const prop in props) {
        if (Object.getOwnPropertyDescriptor(props, prop)) {
          currentContext.props[prop] = props[prop];
        }
      }
    },

    setCurrentContextSort(state, sortBy) {
      const currentContext = this.getters.contextObject;
      currentContext.sortBy = sortBy;
    },

    setSelectedTags(state, selectedTags) {
      const currentContext = this.getters.contextObject;
      currentContext.selectedTags = selectedTags;
    },

    setCurrentSearchContextFilters(state, props) {
      for (const prop in props) {
        if (Object.getOwnPropertyDescriptor(props, prop)) {
          this.getters.contextFilters[prop] = props[prop];
        }
      }
    },

    setCurrentInstagramEntity(state, entity) {
      const context = state.searchContexts.INSTAGRAM;
      context.entity = entity;
      if (entity) {
        context.props.type = entity.type;
      }
    },

    setOpenFilterTabs(state, openFilterTabs) {
      const context = this.getters.contextObject;
      context.openFilterTabs = openFilterTabs;
    },

    setSidebarState(state, sidebarState) {
      state.sidebarState = sidebarState;
    },

    takeAssetsFromBuffer(state) {
      const provider = app.PROVIDERS[state.searchContextId];
      const nextAssets = state.assetBuffer.slice(0, provider.RESULTS_PER_PAGE);
      state.assetBuffer = state.assetBuffer.slice(provider.RESULTS_PER_PAGE);
      state.assetSearchResults = _.uniqBy(
        [...state.assetSearchResults, ...nextAssets],
        'id'
      );
      state.searchInProgress = false;
    },

    addAssetsToBuffer(state, assets) {
      if (!Array.isArray(assets)) {
        assets = [];
      }
      state.assetBuffer = [...state.assetBuffer, ...assets];
    },

    addAssets(state, assets) {
      state.assetSearchResults = _.uniqBy(
        [...state.assetSearchResults, ...assets],
        'id'
      );
    },

    addAssetsAtStart(state, assets) {
      // eslint-disable-next-line prefer-spread
      state.assetSearchResults.unshift.apply(
        state.assetSearchResults,
        _.isArray(assets) ? assets : [assets]
      );
    },

    setNoMoreAssets(state) {
      state.noMoreAssets = true;
    },

    galleryAssetMetadataEdited(state, payload) {
      const searchResultsAsset = state.assetSearchResults.find(
        (tmpAsset) => tmpAsset.metadata.assetUUID === payload.assetUUID
      );

      if (searchResultsAsset) {
        searchResultsAsset.metadata = Object.assign(
          searchResultsAsset.metadata,
          payload.metadata
        );
      }
      // else if (bufferResultsAsset) {
      //     const bufferResultsAsset =
      // state.assetBuffer.find(
      //     tmpAsset => tmpAsset.metadata.assetUUID ===
      //         payload.assetUUID);

      //     bufferResultsAsset.metadata = Object.assign(
      //         bufferResultsAsset.metadata,
      //         payload.metadata);
      // }
    },

    setDeleteInProgress(state, { assetUUID, isInProgress }) {
      const asset = state.assetSearchResults.find(
        (tmpAsset) => tmpAsset.metadata.assetUUID === assetUUID
      );

      if (asset) {
        app.Vue.set(asset, '_deleteInProgress', isInProgress);
      }
    },

    galleryAssetDeleted(state, assetUUID) {
      const assetIndex = state.assetSearchResults.findIndex(
        (tmpAsset) => tmpAsset.metadata.assetUUID === assetUUID
      );

      if (assetIndex >= 0) {
        state.assetSearchResults.splice(assetIndex, 1);
      }

      if (state.searchContextId === 'MY_GALLERY') {
        state.searchContexts.MY_GALLERY.nextItem =
          state.assetSearchResults.length + state.assetBuffer.length;
      }
    },

    setMyUploadsOnly(state, myUploadsOnly) {
      state.myUploadsOnly = myUploadsOnly;
    },
    setMyFavoriteOnly(state, myFavoritesOnly) {
      state.myFavoritesOnly = myFavoritesOnly;
    },

    setSearchContextId(state, searchContextId) {
      state.searchContextId = searchContextId;
    },
    updateVideoDuration(state, { asset, duration }) {
      app.Vue.set(asset.metadata, 'duration', duration);
    },
    toggleFavoriteAsset(state, { asset, isFavorite }) {
      const assetsToChange = [];
      asset = asset.attributes || asset;
      const identifier = app.assetUniqueIdentifier(asset);
      app.Vue.set(
        asset.metadata,
        'favoriteOwner',
        isFavorite ? app.rootStore.state.user['employeeId'] : null
      );

      if (/dynamic/.test(identifier)) {
        assetsToChange.push(
          _.find(
            state.assetSearchResults,
            (a) => a.metadata.providerAssetId === asset.metadata.providerAssetId
          )
        );
      } else {
        assetsToChange.push(
          _.find(
            state.assetSearchResults,
            (a) => a.metadata.assetUUID === asset.metadata.assetUUID
          )
        );
      }

      assetsToChange.forEach((asset) => {
        if (asset) {
          app.Vue.set(
            asset.metadata,
            'favoriteOwner',
            isFavorite ? app.rootStore.state.user['employeeId'] : null
          );
        }
      });
    },
    favoriteInProcessStart(state, { asset }) {
      const identifier = app.assetUniqueIdentifier(asset);
      if (!state.favoriteInProcess[identifier]) {
        state.favoriteInProcess[identifier] = true;
      }
    },
    favoriteInProcessEnd(state, { asset }) {
      const identifier = app.assetUniqueIdentifier(asset);
      app.Vue.delete(state.favoriteInProcess, identifier);
    },
  },

  // @param context {{state, rootState, commit, dispatch, getters, rootGetters}}
  // @param payload
  actions: {
    INIT_ASSET_GALLERY_MODULE({ state, dispatch, getters }) {
      const wochitProviders =
        state.searchContexts[app.PROVIDERS.WOCHIT.id].filters.providers;
      const savedTabId =
        app.storyController.story.remoteStash.get('searchContextId');
      const savedFormat = app.storyController.story.remoteStash.get(
        'searchContextFormat'
      );
      const tabId =
        savedTabId ||
        (_.isEmpty(wochitProviders) ? 'WOCHIT_CREATIVE' : 'WOCHIT');

      if (
        !_.isEmpty(state.searchContexts[tabId]) &&
        getters.displayedAssetGalleryTabs.find((t) => t.id === tabId)
      ) {
        state.searchContextId = tabId;
      } else {
        const firstTab = getters.displayedAssetGalleryTabs[0];
        state.searchContextId = firstTab.id;
      }

      if (!_.isEmpty(savedFormat)) {
        state.searchContexts[state.searchContextId].props.format = savedFormat;
      }

      dispatch('CHANGE_SEARCH_CONTEXT', { id: state.searchContextId });
    },

    RESET_CONTEXT_FILTERS({ state, commit }) {
      commit('resetContextFilters', state.searchContextId);
    },

    RESET_ALL_CONTEXT_FILTERS({ state, commit }) {
      _.each(state.searchContexts, (contextProps, contextId) => {
        if (_.isObject(contextProps.filters)) {
          commit('resetContextFilters', contextId);
        }
      });
    },

    SET_SIDEBAR_STATE({ commit }, sidebarState) {
      commit('setSidebarState', sidebarState);
    },

    SET_INSTAGRAM_ENTITY({ commit }, entity) {
      commit('setCurrentInstagramEntity', entity);
    },

    REFILL_BUFFER_CREATIVE({ commit, state, getters }) {
      const contextId = state.searchContextId;
      const searchContext = state.searchContexts[contextId];

      const { url, props, imageProps, videoProps, countProp, nextItemProp } =
        getters.contextFiltersParamsCreative;

      const rand = app.guid();

      const searchProps = {
        url,
        props,
        imageProps,
        videoProps,
        imageProviderId: state.creativeProviders.image,
        videoProviderId: state.creativeProviders.video,
        countProp,
        nextItemProp: nextItemProp.response,
        rand,
      };
      return app.api.assetGallery.searchCreativeAssets(searchProps).then(
        ({ assets, noMoreAssets }) => {
          if (!state.moduleAttached) {
            return;
          }

          if (noMoreAssets) {
            commit('setNoMoreAssets');
            searchContext[nextItemProp] = null;
          } else {
            searchContext.nextItem += 1;
          }

          assets = getters.afterSearchProcessResult(assets);

          commit('addAssetsToBuffer', assets);
          state.searchInProgress = false;
        },
        (message) => {
          // console.error(message);
        }
      );
    },

    REFILL_BUFFER({ commit, state, getters }) {
      const contextId = state.searchContextId;
      const searchContext = state.searchContexts[contextId];
      const { countProp } = searchContext;
      const provider = app.PROVIDERS[contextId];

      const itemCount = provider.BUFFER_SIZE - state.assetBuffer.length;
      if (!itemCount) {
        return;
      }

      const { props, url, nextItemProp } = getters.contextFiltersParams;
      props[countProp] = itemCount;

      const rand = app.guid();

      return app.api.assetGallery
        .searchAssets({
          url,
          props,
          countProp,
          nextItemProp: nextItemProp.response,
          rand,
          contextId,
        })
        .then(({ assets, noMoreAssets, nextItem }) => {
          if (!state.moduleAttached) {
            return;
          }

          if (noMoreAssets) {
            commit('setNoMoreAssets');
            searchContext[nextItemProp] = null;
          } else {
            if (
              contextId === 'WOCHIT' ||
              contextId === 'MY_GALLERY' ||
              contextId === app.PROVIDERS.FAVORITES.id ||
              contextId === app.PROVIDERS.WOCHIT_OWNED_ASSETS.id
            ) {
              searchContext.nextItem += props[countProp];
            } else if (nextItem) {
              searchContext.nextItem = nextItem;
            }
          }

          assets = getters.afterSearchProcessResult(assets);

          commit('addAssetsToBuffer', assets);
          state.searchInProgress = false;
        })
        .catch((message) => {
          console.error(message);
        });
    },

    CLEAR_STORE({ state, getters }) {
      // remember last tab
      app.storyController.story.remoteStash.set({
        searchContextId: state.searchContextId,
        searchContextFormat: getters.contextObject.props.format,
      });
      // clear big data holders between AssetGallery sessions
      state.assetSearchResults = [];
      state.assetBuffer = [];
      state.moduleAttached = false;
    },

    SEARCH_CREATIVE_ASSETS(
      { commit, dispatch, state, getters, rootState },
      options = {}
    ) {
      options = Object.assign(
        {
          resetSelectedTags: false,
        },
        options
      );

      commit('resetSearchResults', {
        resetSelectedTags: options.resetSelectedTags,
      });

      const contextId = state.searchContextId;
      const searchContext = state.searchContexts[contextId];
      state.searchInProgress = true;
      state.searchFailedError = null;
      const { countProp } = searchContext;

      const { url, props, imageProps, videoProps, nextItemProp } =
        getters.contextFiltersParamsCreative;
      const query = (props[searchContext.queryProp] || '').trim();

      if (searchContext.queryRequired && _.isEmpty(query)) {
        commit('resetSearchResults');
        state.searchInProgress = false;
        return;
      }

      return app.api.assetGallery
        .searchCreativeAssets({
          url,
          props,
          imageProps,
          imageProviderId: state.creativeProviders.image,
          videoProps,
          videoProviderId: state.creativeProviders.video,
          countProp,
          nextItemProp: nextItemProp.response,
          rand: app.guid(),
        })
        .then(
          ({ assets, noMoreAssets }) => {
            if (!state.moduleAttached) {
              return;
            }

            if (noMoreAssets) {
              commit('setNoMoreAssets');
              searchContext[nextItemProp] = null;
            } else {
              searchContext.nextItem = (searchContext.nextItem || 1) + 1;
            }

            assets = getters.afterSearchProcessResult(assets);

            commit('addAssets', assets);

            dispatch('REFILL_BUFFER_CREATIVE');
          },
          (err) => {
            if (err && err.statusText !== 'abort') {
              state.searchInProgress = false;
              state.searchFailedError = err;
            }
          }
        )
        .finally(() => {
          state.searchInProgress = false;
        });
    },

    SEARCH_ASSETS(
      { commit, dispatch, state, getters, rootState },
      options = {}
    ) {
      options = Object.assign(
        {
          resetSelectedTags: false,
        },
        options
      );

      commit('resetSearchResults', {
        resetSelectedTags: options.resetSelectedTags,
      });

      const contextId = state.searchContextId;

      if (contextId === 'WOCHIT_CREATIVE') {
        return dispatch('SEARCH_CREATIVE_ASSETS');
      }
      const searchContext = state.searchContexts[contextId];
      state.searchInProgress = true;
      state.searchFailedError = null;
      const { countProp } = searchContext;

      const { props, url, nextItemProp } = getters.contextFiltersParams;
      const query = (props[searchContext.queryProp] || '').trim();

      if (searchContext.queryRequired && _.isEmpty(query)) {
        commit('resetSearchResults');
        state.searchInProgress = false;
        return;
      }

      return app.api.assetGallery
        .searchAssets({
          url,
          props,
          countProp,
          nextItemProp: nextItemProp.response,
          rand: app.guid(),
          contextId,
        })
        .then(
          ({ assets, tags, nextItem, noMoreAssets }) => {
            if (!state.moduleAttached) {
              return;
            }

            if (noMoreAssets) {
              commit('setNoMoreAssets');
              searchContext[nextItemProp] = null;
            } else {
              if (
                contextId === 'WOCHIT' ||
                contextId === 'MY_GALLERY' ||
                contextId === app.PROVIDERS.FAVORITES.id ||
                contextId === app.PROVIDERS.WOCHIT_OWNED_ASSETS.id
              ) {
                searchContext.nextItem = props[countProp];
              } else if (nextItem) {
                searchContext.nextItem = nextItem;
              }
            }

            assets = getters.afterSearchProcessResult(assets);

            commit('addAssets', assets);
            commit('setSearchTags', tags);
            state.searchInProgress = false;

            return dispatch('REFILL_BUFFER');
          },
          (err) => {
            if (err && err.statusText !== 'abort') {
              state.searchInProgress = false;
              state.searchFailedError = err;
            }
          }
        );
    },

    GET_MORE_ASSETS({ state, dispatch, commit }) {
      if (
        state.assetBuffer.length <
        app.PROVIDERS[state.searchContextId].RESULTS_PER_PAGE * 2
      ) {
        let promise = Promise.resolve();
        state.searchInProgress = true;
        if (app.api.assetGallery.isPending()) {
          promise = app.api.assetGallery.promise;
        } else if (!state.noMoreAssets) {
          if (state.searchContextId === 'WOCHIT_CREATIVE') {
            promise = dispatch('REFILL_BUFFER_CREATIVE');
          } else {
            promise = dispatch('REFILL_BUFFER');
          }
        }
        return promise.then(() => {
          return commit('takeAssetsFromBuffer');
        });
      } else {
        commit('takeAssetsFromBuffer');
        return Promise.resolve();
      }
    },

    SET_PROVIDER_SELECTION({ commit }, { id, selected }) {
      commit('setProviderSelection', { id, selected });
    },

    SET_DATE_SELECTION({ commit }, value) {
      commit('setCurrentSearchContextFilters', { dateRange: value });
    },

    SET_TABS_FILTER_SELECTION({ commit }, openFilterTabs) {
      commit('setOpenFilterTabs', openFilterTabs);
    },

    SET_RESTRICTION_SELECTION({ commit }, value) {
      commit('setCurrentSearchContextFilters', { restrictions: value });
    },

    SET_QUALITY_FILTER_SELECTION({ commit }, videoQuality) {
      commit('setCurrentSearchContextFilters', { videoQuality });
    },

    SET_FORMAT_FILTER_SELECTION({ commit }, value) {
      commit('setCurrentSearchContextFilters', { format: value });
    },

    SET_ORIENTATIONS_SELECTION({ commit }, o) {
      commit('setCurrentSearchContextFilters', o);
    },

    SET_QUERY({ state, commit, getters }, { queryText, queryValue }) {
      const isBestMatch = (option) => {
        if (getters.searchContextId === 'WOCHIT_CREATIVE') {
          return option.id === 'RELEVANCE';
        }
        return !option.id;
      };

      queryValue = queryValue || queryText;
      if (!queryText || _.isEmpty(queryText.trim())) {
        if ('sortBy' in getters.contextObject) {
          const sortBy = getters.contextObject.sortBy;
          const sortProps = state.sortContext[state.searchContextId];
          if (sortProps && sortProps.options && sortProps.options.length) {
            const findSort = sortProps.options.find((s) => s.id === sortBy);
            if (findSort && isBestMatch(findSort)) {
              const firstAvailableSort = sortProps.options.find(
                (s) => !isBestMatch(s)
              );
              if (firstAvailableSort) {
                commit('setCurrentContextSort', firstAvailableSort.id);
              }
            }
          }
        }
      }

      commit('setQuery', { text: queryText, value: queryValue });
    },

    SET_FORMAT({ commit }, format) {
      commit('setCurrentSearchContextProps', { format });
    },

    SET_SORT_BY({ commit }, sortBy) {
      commit('setCurrentContextSort', sortBy);
    },

    SET_SELECTED_TAGS({ commit }, selectedTags) {
      commit('setSelectedTags', selectedTags);
    },

    CHANGE_SEARCH_CONTEXT(
      { commit, state, getters },
      { id, initialValue = '' }
    ) {
      if (app.api.assetGallery.isPending()) {
        app.api.assetGallery.abort();
        state.searchInProgress = false;
      }

      commit('resetSearchResults');
      commit('changeSearchContext', { id, initialValue });

      if (!getters.hasDefaultContextFilters) {
        commit('setSidebarState', 'filter');
      } else {
        commit('setSidebarState', null);
      }
    },

    GALLERY_ASSET_METADATA_EDITED({ commit }, payload) {
      commit('galleryAssetMetadataEdited', payload);
    },

    ABORT_GALLERY_UPLOAD_ASSET({ commit }, asset) {
      // FEATURE(20%): abort unfinished uploads - you can find it
      // in UploadQueue and abort the upload (
      //    uploadQueueModel->worker->xhr->abort
      // )

      commit('removeGalleryUploadingAsset', asset);
    },

    GALLERY_UPLOAD_DONE({ commit, state }, asset) {
      // NOTE: action called from view watcher - only if uploading asset item view is visible
      commit('removeGalleryUploadingAsset', asset);
      const found = _.some(state.assetSearchResults, (a) => a.id === asset.id);
      if (!found) {
        commit('addAssetsAtStart', asset);
      }
    },

    ASSET_DELETE({ state, commit }, assetUUID) {
      commit('setDeleteInProgress', { assetUUID, isInProgress: true });
      app.api.asset.delete(assetUUID).then(
        () => {
          commit('galleryAssetDeleted', assetUUID);
        },
        () => {
          commit('setDeleteInProgress', { assetUUID, isInProgress: false });
          app.dialog.error({
            type: app.dialog.types.ERROR_1,
            title: 'Delete Failed',
            showContactCsm: true,
          });
        }
      );
    },

    SET_MY_UPLOADS({ commit }, myUploadsOnly) {
      commit('setMyUploadsOnly', myUploadsOnly);
    },
    SET_MY_FAVORITE({ commit }, myFavoritesOnly) {
      app.analytics('analytics:favorite:toggleMyFavorite', {
        ToggleValue: myFavoritesOnly ? 'my' : 'team',
      });
      commit('setMyFavoriteOnly', myFavoritesOnly);
    },
    /**
     * toggle the asset favorite
     * @param {commit}
     * @param {*} asset the asset to toggle favorite
     */
    TOGGLE_FAVORITE_ASSET: function (
      { state, commit, getters },
      { asset, duration }
    ) {
      const favoriteOwner = asset.metadata.favoriteOwner;
      // get the asset uuid from the metadata.
      const assetUUID = asset.metadata.assetUUID;
      const isFavorite = !favoriteOwner;
      const isDynamicProvider = app.assetType.isDynamicProvider(asset);
      // check if this asset is in process
      if (!getters.isAssetProcessingFavorite(asset)) {
        // save, on the asset variable, that the asset is in progress
        commit('favoriteInProcessStart', { asset });

        if (duration) {
          commit('updateVideoDuration', { asset, duration });
        }
        commit('toggleFavoriteAsset', { asset, isFavorite });

        let promise;

        // if the asset isn't favorite and gif or social there is a need
        // to index this asset in the elastic search before favorite him
        if (
          isFavorite &&
          ((app.assetType.isGIF(asset) &&
            !app.assetType.isInMyGallery(asset)) ||
            app.assetType.isSOCIAL(asset) ||
            isDynamicProvider)
        ) {
          // create the data for the post request for indexing.
          const postData =
            app.namespace.Controller.AssetController.serializeAsset(asset);

          // overwrite the promise with a request to index the asset
          promise = app.api.asset.convert(postData).then((response) => {
            // after the asset been index wait for a firebase call from
            // elastic search that the asset been indexed in elastic search
            if (response.status === 'DONE') {
              return Promise.resolve({ assetUUID });
            }
            return Promise.resolve(
              app.api.realTime.listenOnAsset(assetUUID, { isDynamicProvider })
            );
          });
        } else {
          promise = Promise.resolve({ assetUUID });
        }

        return promise
          .then(() => {
            // on resolve create new promise that call favorite
            // API to favorite / un-favorite the asset.
            return app.api.asset
              .favorite(asset.metadata, isFavorite)
              .then(() => {
                if (!state.moduleAttached) {
                  return;
                }

                return new Promise((resolve) => {
                  _.delay(() => {
                    // toggle favorite. (same value, AGAIN,
                    // just in case user refresh the gallery results and got another asset id)
                    commit('toggleFavoriteAsset', { asset, isFavorite });
                    resolve();
                  }, app.TIME.second(0.5));
                });
              });
          })
          .catch((error) => {
            console.error(error);
            app.notificationController.push({
              text: 'Something went wrong. Try again.',
              type: 'ERROR',
              uniqueGroupName: 'TOGGLE_FAVORITE',
            });
            commit('toggleFavoriteAsset', { asset, isFavorite: !isFavorite });
          })
          .finally(() => {
            // when finish remove the asset._favoriteInProcess
            commit('favoriteInProcessEnd', { asset });
            if (isFavorite) {
              app.analytics('analytics:favorite:favorite', {
                'asset type': asset.type,
              });
            } else {
              app.analytics('analytics:favorite:unfavorite', {
                'asset type': asset.type,
                IsMyFavorite:
                  favoriteOwner === app.rootStore.getters['user/id'],
              });
            }
          });
      }
    },
  },
};
